<!-- payku-create-button.component.html -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="card mb-4 payku-card shadow-sm">
	<div class="card-body d-flex flex-column flex-md-row justify-content-between align-items-center">
		<!-- Texto -->
		<div class="payku-text pe-md-4 mb-3 mb-md-0">
			<h5 class="card-title mb-1">Activa Payku en tu empresa</h5>
			<p class="card-text mb-0">Crea tu cuenta Payku para recibir pagos de tus clientes de forma rápida y segura.</p>
		</div>
		<!-- Botón -->
		<button id="paykuCreateBtn" class="btn btn-payku px-4 py-2" (click)="onCreate()">
			<i class="fas fa-plus-circle me-2"></i>
			Crear cuenta
		</button>
	</div>
</div>
